/* eslint-disable @typescript-eslint/no-use-before-define */
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Option } from "react-bootstrap-typeahead/types/types";

import { IWorkflowOvertime } from "../../../../context/interfaces/IWorkflowContext";
import { axiosGetRequest } from "../../../../api/ApiClient";
import Dialog from "../../../../components/Dialog";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import {
    OvertimeWorkflowDetailsWrapper,
    OvertimeWorkflowDetailsHeader,
    OvertimeWorkflowDetailsBody,
    OvertimeWorkflowDetailsButtonsWrapper,
    OvertimeWorkflowDetailsTextWrapper,
} from "../../../../styles/components/OvertimeWorkflowDetails";
import { InformationIcon, UserIcon } from "../../../../components/Icons";
import SelectOption from "../../../../model/SelectOption";
import GenericUtils from "../../../../utils/GenericUtils";
import AutoCompleteClean from "../../../../components/AutoCompleteClean";
import CheckRadioStyles from "../../../../styles/components/BlueCheckRadioStyles";
// import CheckRadioStyles from "../styles/components/CheckRadioStyles";
import InputLabelTextArea from "../../../../components/InputLabelTextArea";
import StringUtils from "../../../../utils/types/StringUtils";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const CAMPUS = "campus";
const SCHOOL = "school";
const MODALITY = "modality";
const RESULT_CENTER = "resultCenter";

const WORKFLOW_APROVED_STATUS = "APROVADO";
interface IModalProps {
    open: boolean;
    workflow: IWorkflowOvertime | null;
    onClose: (callback?: any) => void;
    onDeferir: (workflow: OvertimeDeferralFieldsType) => void;
    hasToShowFormFields: boolean;
}

type OvertimeDeferralFieldsType = {
    campus: string;
    modality: string;
    school: string;
    resultCenter: string;
    guidanceLetter: boolean;
    details: string;
    justification?: string;
};

type OptionValue = {
    value: string;
};
// NOSONAR
const initialData = {
    campus: "",
    modality: "",
    school: "",
    resultCenter: "",
    guidanceLetter: false,
    details: "",
};
// NOSONAR
const OvertimeModal: React.FC<IModalProps> = ({
    open,
    workflow,
    onClose,
    onDeferir,
    hasToShowFormFields = true,
}) => {
    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();

    const [isConfirm, setIsConfirm] = useState<boolean>(false);
    const [confirmButtonDisabled, setConfirmButtonDisabled] =
        useState<boolean>(true);
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [campusAutoCompleteList, setCampusAutoCompleteList] = useState<
        SelectOption[]
    >([]);
    const [modalityAutoCompleteList, setModalityAutoCompleteList] = useState<
        SelectOption[]
    >([]);
    const [schoolAutoCompleteList, setSchoolAutoCompleteList] = useState<
        SelectOption[]
    >([]);
    const [resultCenterAutoCompleteList, setResultCenterAutoCompleteList] =
        useState<SelectOption[]>([]);

    const [overtimeDeferralFields, setOvertimeDeferralFields] =
        useState<OvertimeDeferralFieldsType>(initialData);

    const handleChangeDeferralFields = (name: string, value: string) => {
        setOvertimeDeferralFields({
            ...overtimeDeferralFields,
            [name]: value,
        });
    };
    // NOSONAR
    const handleOnClose = () => {
        setIsConfirm(false);
        setOvertimeDeferralFields(initialData);
        setConfirmButtonDisabled(true);
        onClose();
    };
    // NOSONAR
    const handleOnConfirmClicked = () => {
        onDeferir(overtimeDeferralFields);
        setIsConfirm(false);
        // setOvertimeDeferralFields(initialData);
        setConfirmButtonDisabled(true);
    };

    useEffect(() => {
        const objectIsEmpty = Object.values(overtimeDeferralFields).some(
            (value) => value === ""
        );

        setIsFormValid(!objectIsEmpty);
    }, [overtimeDeferralFields]);

    const getResultsCenter = async (campus: string, school: string) => {
        const newResultCenter: SelectOption[] = [];

        const modalityId = modalityAutoCompleteList.find(
            (modality) => modality.value === overtimeDeferralFields.modality
        ) || { value: "" };

        const response = await axiosGetRequest(
            `/docente/v1/centroresultados?campusId=${campus}&modalidadeId=${modalityId.value}&escolaId=${school}&abrangenciaId=not:4`,
            acessToken,
            instance
        );

        if (!response || !response.data) {
            return;
        }

        const { centroResultados } = response.data;
        const filteredResultCenters = centroResultados.filter(
            (resultCenter: any) => resultCenter.campus.id === campus
        );

        filteredResultCenters.map((data: any) =>
            newResultCenter.push({
                value: data.id,
                label: data.nome,
            })
        );

        setResultCenterAutoCompleteList(newResultCenter);
    };

    const getSchool = async (campus: string, modality: string) => {
        const newSchool: SelectOption[] = [];

        const schoolResponse = await axiosGetRequest(
            `/docente/v1/centroresultados/campi/${campus}/modalidades/${modality}/escolas`,
            acessToken,
            instance
        );

        if (!schoolResponse || !schoolResponse.data) {
            return;
        }

        const { data } = schoolResponse;

        data.map((actualSchool: any) =>
            newSchool.push({
                value: actualSchool,
                label: actualSchool,
            })
        );

        setSchoolAutoCompleteList(newSchool);
    };

    const getModality = async (campus: string) => {
        const newModality: SelectOption[] = [];

        const modalityResponse = await axiosGetRequest(
            `/docente/v1/centroresultados/campi/${campus}/modalidades`,
            acessToken,
            instance
        );

        if (!modalityResponse || !modalityResponse.data) {
            return;
        }

        const { data } = modalityResponse;

        data.map((actualModality: any) =>
            newModality.push({
                value: actualModality.modalidadeId,
                label: actualModality.modalidadeDescricao,
            })
        );

        setModalityAutoCompleteList(newModality);
    };

    const getCampus = async () => {
        const campus: SelectOption[] = [];

        const campusResponse = await axiosGetRequest(
            `/docente/v1/campi`,
            acessToken,
            instance
        );

        if (!campusResponse) {
            return;
        }

        const { campi } = campusResponse.data;
        campi.map((data: any) =>
            campus.push({
                value: data.name,
                label: data.name,
            })
        );

        setCampusAutoCompleteList(campus);
    };

    const getValueFromOption = (option: Option[]) => {
        return option[0] ? (option[0] as OptionValue) : { value: "" };
    };

    const clearFields = () => {
        setOvertimeDeferralFields(initialData);
        setModalityAutoCompleteList([]);
    };

    const handleCampusFieldChange = (event: Option[], paramName: string) => {
        const { value } = getValueFromOption(event);

        if (value === "") {
            clearFields();
            return;
        }

        handleChangeDeferralFields(paramName, value);
        getModality(value);
    };

    const handleModalityFieldChange = (event: Option[], paramName: string) => {
        const { value } = getValueFromOption(event);

        if (value === "") {
            setOvertimeDeferralFields({
                ...overtimeDeferralFields,
                modality: "",
                school: "",
                resultCenter: "",
            });
            return;
        }

        const modalityName =
            modalityAutoCompleteList.find(
                (modality) => modality.value === value
            )?.label || "";

        handleChangeDeferralFields(paramName, value);
        getSchool(overtimeDeferralFields.campus, modalityName);
    };

    const handleSchoolFieldChange = (event: Option[], paramName: string) => {
        const { value } = getValueFromOption(event);

        if (value === "") {
            setOvertimeDeferralFields({
                ...overtimeDeferralFields,
                school: "",
                resultCenter: "",
            });

            return;
        }

        handleChangeDeferralFields(paramName, value);
        getResultsCenter(overtimeDeferralFields.campus, value);
    };

    const handleResultCenterFieldChange = (
        event: Option[],
        paramName: string
    ) => {
        const { value } = getValueFromOption(event);

        if (value === "") {
            setOvertimeDeferralFields({
                ...overtimeDeferralFields,
                resultCenter: "",
            });

            return;
        }

        handleChangeDeferralFields(paramName, value);
    };

    useEffect(() => {
        getCampus();

        return () => {
            // setCampusAutoCompleteList([]);
            setConfirmButtonDisabled(true);
        };
    }, []);

    return (
        <Dialog
            openModal={open}
            onHide={handleOnClose}
            size="lg"
            style={{
                width: "100%",
            }}
            dialogClassName="modal-90w"
        >
            <OvertimeWorkflowDetailsWrapper>
                <OvertimeWorkflowDetailsHeader>
                    <h1>Hora Letiva RE</h1>
                    <div>
                        <p>
                            <UserIcon
                                style={{
                                    fill: "#8A0538",
                                    width: "14px",
                                }}
                            />
                            {workflow?.nomeDocente}
                        </p>
                        <p>
                            <InformationIcon
                                style={{
                                    fill: "#8A0538",
                                    width: "16px",
                                }}
                            />
                            {`Matricula: ${workflow?.matriculaAdp}`}
                        </p>
                    </div>
                    <p className="overtime_information_header">
                        Confira abaixo os cartões de Hora Letiva RE
                    </p>
                </OvertimeWorkflowDetailsHeader>
                <OvertimeWorkflowDetailsBody>
                    {/* TODO: Remover a table e fazer de outra maneira, talvez criando um componente */}
                    <table>
                        <tbody>
                            <tr>
                                <td className="table_firts_column">
                                    Data da Alocação:
                                </td>
                                <td>
                                    {StringUtils.formatDateString(
                                        workflow?.dtAlocacaoCartao ?? "",
                                        "dd/MM/yyyy"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Nome da Atividade:
                                </td>
                                <td>{workflow?.nomeAtividade}</td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Data de Criação do Cartão:
                                </td>
                                <td>
                                    {StringUtils.formatDateString(
                                        workflow?.created ?? "",
                                        "dd/MM/yyyy"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Hora Início/Fim:
                                </td>
                                <td>{`${workflow?.horaInicio} - ${workflow?.horaFim}`}</td>
                            </tr>
                            {(isConfirm || hasToShowFormFields) && (
                                <>
                                    <tr>
                                        <td className="table_firts_column">
                                            Campus:
                                        </td>
                                        <td>
                                            <AutoCompleteClean
                                                // label="Campus"
                                                options={campusAutoCompleteList}
                                                onChange={(event: Option[]) => {
                                                    handleCampusFieldChange(
                                                        event || [],
                                                        CAMPUS
                                                    );
                                                }}
                                                placeholder="Selecione o Campus"
                                                style={{ width: "100%" }}
                                                selected={
                                                    overtimeDeferralFields.campus
                                                        ? [
                                                              {
                                                                  value: overtimeDeferralFields.campus,
                                                                  label: campusAutoCompleteList.find(
                                                                      (item) =>
                                                                          item.value ===
                                                                          overtimeDeferralFields.campus
                                                                  )?.label,
                                                              },
                                                          ]
                                                        : []
                                                }
                                                defaultSelected={[]}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="table_firts_column">
                                            Modalidade:
                                        </td>
                                        <td>
                                            <AutoCompleteClean
                                                // label="Modalidade"
                                                options={
                                                    modalityAutoCompleteList
                                                }
                                                onChange={(event: Option[]) => {
                                                    handleModalityFieldChange(
                                                        event || [],
                                                        MODALITY
                                                    );
                                                }}
                                                placeholder="Selecione a Modalidade"
                                                disabled={
                                                    !overtimeDeferralFields.campus
                                                }
                                                style={{ width: "100%" }}
                                                selected={
                                                    overtimeDeferralFields.modality
                                                        ? [
                                                              {
                                                                  value: overtimeDeferralFields.modality,
                                                                  label: modalityAutoCompleteList.find(
                                                                      (item) =>
                                                                          item.value ===
                                                                          overtimeDeferralFields.modality
                                                                  )?.label,
                                                              },
                                                          ]
                                                        : []
                                                }
                                                defaultSelected={[]}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="table_firts_column">
                                            Escola:
                                        </td>
                                        <td>
                                            <AutoCompleteClean
                                                // label="Escola/Curso"
                                                options={schoolAutoCompleteList}
                                                onChange={(event: Option[]) => {
                                                    handleSchoolFieldChange(
                                                        event || [],
                                                        SCHOOL
                                                    );
                                                }}
                                                // options={covegage}
                                                placeholder="Selecione a Escola/Curso"
                                                // selected={selectedCoverage}
                                                disabled={
                                                    !overtimeDeferralFields.modality
                                                }
                                                style={{ width: "100%" }}
                                                selected={
                                                    overtimeDeferralFields.school
                                                        ? [
                                                              {
                                                                  value: overtimeDeferralFields.school,
                                                                  label: overtimeDeferralFields.school,
                                                              },
                                                          ]
                                                        : []
                                                }
                                                defaultSelected={[]}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="table_firts_column">
                                            Centro de Resultado:
                                        </td>
                                        <td>
                                            <AutoCompleteClean
                                                // label="Centro de Resultados"
                                                options={
                                                    resultCenterAutoCompleteList
                                                }
                                                onChange={(event: Option[]) => {
                                                    handleResultCenterFieldChange(
                                                        event || [],
                                                        RESULT_CENTER
                                                    );
                                                }}
                                                // options={covegage}
                                                placeholder="Selecione o Centro de Resultados"
                                                // selected={selectedCoverage}
                                                disabled={
                                                    !overtimeDeferralFields.school
                                                }
                                                style={{ width: "100%" }}
                                                selected={
                                                    overtimeDeferralFields.resultCenter
                                                        ? [
                                                              {
                                                                  value: overtimeDeferralFields.resultCenter,
                                                                  label: resultCenterAutoCompleteList.find(
                                                                      (item) =>
                                                                          item.value ===
                                                                          overtimeDeferralFields.resultCenter
                                                                  )?.label,
                                                              },
                                                          ]
                                                        : []
                                                }
                                                defaultSelected={[]}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="table_firts_column">
                                            Carta de Orientação:
                                        </td>
                                        <td className="checkbox_wrapper">
                                            <CheckRadioStyles.StyledFormCheck
                                                inline
                                                label="Sim"
                                                name="guidance_radio"
                                                type="radio"
                                                id="guidance_radio_1"
                                                onChange={() => {
                                                    setOvertimeDeferralFields({
                                                        ...overtimeDeferralFields,
                                                        guidanceLetter: true,
                                                    });
                                                }}
                                                checked={
                                                    overtimeDeferralFields.guidanceLetter
                                                }
                                            />
                                            <CheckRadioStyles.StyledFormCheck
                                                inline
                                                label="Não"
                                                name="guidance_radio"
                                                type="radio"
                                                id="guidance_radio_2"
                                                checked={
                                                    !overtimeDeferralFields.guidanceLetter
                                                }
                                                onChange={() => {
                                                    setOvertimeDeferralFields({
                                                        ...overtimeDeferralFields,
                                                        guidanceLetter: false,
                                                    });
                                                }}
                                            />
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                    {(isConfirm || hasToShowFormFields) && (
                        <OvertimeWorkflowDetailsTextWrapper>
                            <p>Detalhes</p>
                            <InputLabelTextArea
                                value={overtimeDeferralFields.details}
                                placeholder="Insira aqui os detalhes da atividade"
                                onChange={(event: any) =>
                                    setOvertimeDeferralFields({
                                        ...overtimeDeferralFields,
                                        details: event.target.value,
                                    })
                                }
                                viewLengthInfo
                                maxLength={500}
                                style={{
                                    height: "107px",
                                    borderStyle: "solid",
                                    borderColor: "#787878",
                                    width: "100%",
                                }}
                            />
                        </OvertimeWorkflowDetailsTextWrapper>
                    )}
                    <OvertimeWorkflowDetailsButtonsWrapper>
                        {confirmButtonDisabled && !hasToShowFormFields ? (
                            <BtnPrimary
                                style={{ width: 126, marginTop: 24 }}
                                onClick={() => {
                                    setIsConfirm(true);
                                    setConfirmButtonDisabled(false);
                                }}
                                disabled={
                                    workflow?.status === WORKFLOW_APROVED_STATUS
                                }
                            >
                                Concluir
                            </BtnPrimary>
                        ) : (
                            <BtnPrimary
                                style={{ width: 126, marginTop: 24 }}
                                onClick={() => handleOnConfirmClicked()}
                                disabled={!isFormValid}
                            >
                                Concluir
                            </BtnPrimary>
                        )}

                        <DefaultButtonLink onClick={() => handleOnClose()}>
                            Cancelar
                        </DefaultButtonLink>
                    </OvertimeWorkflowDetailsButtonsWrapper>
                </OvertimeWorkflowDetailsBody>
            </OvertimeWorkflowDetailsWrapper>
        </Dialog>
    );
};

export default OvertimeModal;
export type { OvertimeDeferralFieldsType };
